import Vue from 'vue'
import Vuex from 'vuex'
import {UserModule} from './modules/User';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        allRegions: [
            {
                key: 'DS',
                value: 'dolnośląskie'
            },
            {
                key: 'KP',
                value: 'kujawsko-pomorskie'
            },
            {
                key: 'LB',
                value: 'lubelskie'
            },
            {
                key: 'LS',
                value: 'lubuskie'
            },
            {
                key: 'LD',
                value: 'łódzkie'
            },
            {
                key: 'MP',
                value: 'małopolskie'
            },
            {
                key: 'MZ',
                value: 'mazowieckie'
            },
            {
                key: 'OP',
                value: 'opolskie'
            },
            {
                key: 'PK',
                value: 'podkarpackie'
            },
            {
                key: 'PL',
                value: 'podlaskie'
            },
            {
                key: 'PM',
                value: 'pomorskie'
            },
            {
                key: 'ŚL',
                value: 'śląskie'
            },
            {
                key: 'SK',
                value: 'świętokrzyskie'
            },
            {
                key: 'WM',
                value: 'warmińsko-mazurskie'
            },
            {
                key: 'WP',
                value: 'wielkopolskie'
            },
            {
                key: 'ZP',
                value: 'zachodniopomorskie'
            }
        ],
    },
    mutations: {},
    getters: {
        getAllRegions(state) {
            return state.allRegions
        },
    },
    actions: {},
    modules: {
      user: new UserModule
    }

});
